import moment from 'moment';

const getFormattedDate = (data, dateFormat = "MM/DD/YYYY h:mmA") => {
    return moment(data).format(dateFormat)
}

const diffInDays = (startDate, endDate) => {
    return endDate.diff(startDate, 'days')
}

const getCurrentDate = () => {
    return moment()
}

export { getFormattedDate, diffInDays, getCurrentDate }